<div class="group-separator position-relative text-center">
  <span class="d-inline-block">Grupo {{ group() }}</span>
</div>

<!-- Jugadores -->
<div class="row mt-20">
  <div class="col-12">
    <players-ui
      [drawings]="groupDrawings()"
    ></players-ui>
  </div>
</div>

<!-- Partidos -->
<div class="row mt-30">
  <div class="col-12">
    <games-ui
      [games]="groupGames()"
    ></games-ui>
  </div>
</div>

<!-- Tabla de posiciones -->
<div class="row mt-10">
  <div class="col-12">
    <rankings-ui
      [groupsRankings]="groupGroupsRankings()"
    ></rankings-ui>
  </div>
</div>
